module.exports = __webpack_public_path__ + "static/img/327.b4dbb3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/327.jpg
// module id = vHfH
// module chunks = 0